<template>
  <div class="row">
    <!-- Data Analytic-->
    <div class="col-12">
      <div class="row">
        <div class="col-lg-2">
          <h3 class="analytic">Data Analytic</h3>
        </div>
        <div class="col-lg-4">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            align="right"
            unlink-panels
            start-placeholder="Start date"
            end-placeholder="End date"
            @change="callLightData()"
          ></el-date-picker>
        </div>
        <div class="col-lg-6 text-right il">
          <base-button
            simple
            type="primary"
            style="margin-top: 0px"
            @click.native="generateReport"
          >
            <i class="tim-icons icon-chart-bar-32"></i>
            <div style="padding-top: 3px">Generate Report</div>
          </base-button>
        </div>
      </div>
    </div>

    <!-- Savings-->
    <div class="col-12">
      <div class="row">
        <div class="head">
          <div class="col-lg">
            <h4>
              Savings | Electricity tariff : ({{ deviceTariff }} MYR per KwH)
            </h4>
            <!-- <h4>
              Savings (Compared to {{ deviceOldSon }} SON) | Electricity tariff
              : ({{ deviceTariff }} MYR per KwH)
            </h4> -->
          </div>
        </div>
      </div>
    </div>

    <!-- Cost Saving (MYR) -->
    <div class="col-lg-4 col-md-6">
      <card type="chart">
        <loading
          loader="spinner"
          :height="40"
          :width="40"
          color="#00f2c3"
          background-color="#6c757d"
          transition="fade"
          :active="isLoading"
          :is-full-page="false"
        ></loading>
        <template slot="header">
          <h5 class="card-category">Cost Saving (MYR)</h5>
          <h3 class="card-title">
            <p v-html="costSaving"></p>
          </h3>
          <div slot="footer"></div>
        </template>
      </card>
    </div>

    <!-- Energy Saving (kWh) -->
    <div class="col-lg-4 col-md-6">
      <card type="chart">
        <loading
          loader="spinner"
          :height="40"
          :width="40"
          color="#00f2c3"
          background-color="#6c757d"
          transition="fade"
          :active="isLoading"
          :is-full-page="false"
        ></loading>
        <template slot="header">
          <h5 class="card-category">Energy Saving (kWh)</h5>
          <h3 class="card-title">
            <p v-html="energySaving"></p>
          </h3>
          <div slot="footer"></div>
        </template>
      </card>
    </div>

    <!-- Co2 (Kg) -->
    <div class="col-lg-4 col-md-6">
      <card type="chart">
        <loading
          loader="spinner"
          :height="40"
          :width="40"
          color="#00f2c3"
          background-color="#6c757d"
          transition="fade"
          :active="isLoading"
          :is-full-page="false"
        ></loading>
        <template slot="header">
          <h5 class="card-category">Co2 (Kg)</h5>
          <h3 class="card-title">
            <p v-html="co2"></p>
          </h3>
          <div slot="footer"></div>
        </template>
      </card>
    </div>

    <div class="col-lg-12">
      <div class="row">
        <!-- Voltage usage chart -->
        <div class="col-lg-6 col-md-6">
          <div class="head">
            <div class="col-lg">
              <h4>Voltage usage</h4>
            </div>
          </div>
          <card type="card-chart">
            <loading
              loader="spinner"
              :height="40"
              :width="40"
              color="#00f2c3"
              background-color="#6c757d"
              transition="fade"
              :active="isLoading"
              :is-full-page="false"
            ></loading>
            <template slot="header">
              <!-- <h5 class="card-category">Co2 (Kg)</h5> -->
              <h3 class="card-title">
                <!-- <p v-html="co2"></p> -->
                <!-- chart -->
                <div class="chart-area">
                  <line-chart
                    v-if="lineChart1.loaded"
                    chart-id="line-chart-1"
                    :chart-data="lineChart1.chartData"
                    :gradient-colors="lineChart1.gradientColors"
                    :gradient-stops="lineChart1.gradientStops"
                    :extra-options="lineChart1.extraOptions"
                    :height="320"
                  ></line-chart>
                </div>
              </h3>
              <div slot="footer"></div>
            </template>
          </card>
        </div>

        <!-- Current usage chart -->
        <div class="col-lg-6 col-md-6">
          <div class="head">
            <div class="col-lg">
              <h4>Current usage</h4>
            </div>
          </div>
          <card type="card-chart">
            <loading
              loader="spinner"
              :height="40"
              :width="40"
              color="#00f2c3"
              background-color="#6c757d"
              transition="fade"
              :active="isLoading"
              :is-full-page="false"
            ></loading>
            <template slot="header">
              <!-- <h5 class="card-category">Co2 (Kg)</h5> -->
              <h3 class="card-title">
                <!-- <p v-html="co2"></p> -->
                <!-- chart -->
                <div class="chart-area">
                  <line-chart
                    v-if="lineChart2.loaded"
                    chart-id="line-chart-2"
                    :chart-data="lineChart2.chartData"
                    :gradient-colors="lineChart2.gradientColors"
                    :gradient-stops="lineChart2.gradientStops"
                    :extra-options="lineChart2.extraOptions"
                    :height="320"
                  ></line-chart>
                </div>
              </h3>
              <div slot="footer"></div>
            </template>
          </card>
        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="row">
        <!-- Energy usage chart -->
        <div class="col-lg-6 col-md-6 ml-auto">
          <div class="head">
            <div class="col-lg">
              <h4>Energy Usage</h4>
            </div>
          </div>
          <card type="card-chart">
            <loading
              loader="spinner"
              :height="40"
              :width="40"
              color="#00f2c3"
              background-color="#6c757d"
              transition="fade"
              :active="isLoading"
              :is-full-page="false"
            ></loading>
            <template slot="header">
              <!-- <h5 class="card-category">Co2 (Kg)</h5> -->
              <h3 class="card-title">
                <!-- <p v-html="co2"></p> -->
                <!-- chart -->
                <div class="chart-area">
                  <line-chart
                    v-if="lineChart3.loaded"
                    chart-id="line-chart-3"
                    :chart-data="lineChart3.chartData"
                    :gradient-colors="lineChart3.gradientColors"
                    :gradient-stops="lineChart3.gradientStops"
                    :extra-options="lineChart3.extraOptions"
                    :height="320"
                  ></line-chart>
                </div>
              </h3>
              <div slot="footer"></div>
            </template>
          </card>
        </div>

        <!-- Light operating hours chart -->
        <div class="col-lg-6 col-md-6">
          <div class="head">
            <div class="col-lg">
              <h4>Light operating hours</h4>
            </div>
          </div>
          <card type="card-chart">
            <loading
              loader="spinner"
              :height="40"
              :width="40"
              color="#00f2c3"
              background-color="#6c757d"
              transition="fade"
              :active="isLoading"
              :is-full-page="false"
            ></loading>
            <template slot="header">
              <!-- <h5 class="card-category">Co2 (Kg)</h5> -->
              <h3 class="card-title">
                <!-- <p v-html="co2"></p> -->
                <!-- chart -->
                <div class="chart-area">
                  <pie-chart
                    v-if="pieChart2.loaded"
                    :chart-data="pieChart2.chartData"
                    :extra-options="pieChart2.extraOptions"
                    :height="320"
                  ></pie-chart>
                </div>
              </h3>
              <div slot="footer"></div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option, DatePicker } from "element-ui";
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import PieChart from "src/components/Charts/PieChart";
import * as chartConfigs from "@/components/Charts/config";
import config from "@/config";
import moment from "moment";
import jsPDF from "jspdf";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [DatePicker.name]: DatePicker,
    LineChart,
    BarChart,
    PieChart,
    Loading,
  },
  data() {
    return {
      isLoading: true,
      dateRange: [],
      totalDay: 0,
      //Device details
      deviceAssocAttr: null,
      deviceAttr: null,
      deviceInfo: null,
      deviceID: null,
      deviceToken: null,
      deviceTariff: null,
      deviceOldSon: null,

      // Savings data
      sliderValue: null,
      co2: 0.0,
      energySaving: 0.0,
      costSaving: 0.0,
      totalLightOn: 0,

      // Selecting interval data
      selects: {
        time: [
          { value: "24Hours", label: "24 Hours interval" },
          { value: "7Days", label: "7 Days interval" },
        ],
        selectedTime: "",
      },

      // Pie Chart default data
      pieChart2: {
        chartData: {
          labels: [
            "10%",
            "20%",
            "30%",
            "40%",
            "50%",
            "60%",
            "70%",
            "80%",
            "90%",
            "100%",
          ],
          datasets: [
            {
              label: "Dimm percent",
              pointRadius: 0,
              backgroundColor: [
                "#5D3FB6",
                "#3F9BB1",
                "#8EB542",
                "#FAD01A",
                "#F57C21",
                "#EF4528",
                "#CB0B5B",
                "#EF4530",
                "#CB0B0B",
                "#A9336B",
              ],
              pointHoverRadius: 0,
              borderWidth: 0,
              data: [60, 40, 20, 50, 10, 5, 8, 51, 20, 34],
            },
          ],
        },
        loaded: false,
        extraOptions: {
          maintainAspectRatio: false,
          legend: {
            display: true,
            position: "left",
          },
          cutoutPercentage: 50,
        },
      },

      // Line Chart default data
      lineChart1: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Data",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 100, 70, 80, 120, 80],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: false,
      },
      lineChart2: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Data",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 100, 70, 80, 120, 80],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: false,
      },
      lineChart3: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Data",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 100, 70, 80, 120, 80],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: false,
      },
    };
  },

  methods: {
    getClusterScheduler(clusterID) {
      const arr = [];
      this.$http
        .get(":8002/api/v1/manage/cluster/" + clusterID)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            console.log(res.message);
          } else {
            // data
            let clusterData = res.message;
            console.log("CLUSTER_DATA:", clusterData);

            if (clusterData.schedule_info.state == "1") {
              clusterData.schedule_info.weekdays.map((i) => {
                parseInt(i.slice(10, 12), 16) === 1 ? this.totalLightOn++ : 0;
              });
            } else if (clusterData.schedule_info.state == "2") {
              clusterData.schedule_info.weekends.map((i) => {
                parseInt(i.slice(10, 12), 16) === 1 ? this.totalLightOn++ : 0;
              });
            } else if (clusterData.schedule_info.state == "3") {
              clusterData.schedule_info.holidays.map((i) => {
                parseInt(i.slice(10, 12), 16) === 1 ? this.totalLightOn++ : 0;
              });
            }

            console.log("TOTAL_LIGHT_ON:", this.totalLightOn);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getDeviceDetails() {
      let deviceid = this.$route.params.deviceid;
      this.deviceID = deviceid;

      const arr = [];
      this.$http
        .get(":8002/api/v1/manage/device/" + deviceid)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            console.log(res.message);
          } else {
            let clusterID;

            // data
            let deviceData = res.message.deviceinfo[0];

            // assign token
            this.devicetoken = deviceData.devicetoken;

            //get device attribute data
            res.message.assoc_attributes.map((i) => {
              i.key == "CLUSTER_TARIFF_RATE"
                ? ((this.deviceTariff = parseFloat(i.value)),
                  (clusterID = i.entityid))
                : 0;
              i.key == "CLUSTER_OLD_SON"
                ? (this.deviceOldSon = parseInt(i.value, 10))
                : 0;
            });

            console.log("CLUSTER_OLD_SON: " + this.deviceOldSon);

            //get Cluster schedule
            this.getClusterScheduler(clusterID);

            this.callLightData(this.selects.selectedTime);
          }
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    generateReport() {
      var doc = jsPDF("p", "mm", "a4");

      doc.setFontSize(8);
      doc.text(`Date generated : ${moment().format("LLL")}`, 5, 7);

      doc.setFontSize(18);
      doc.setFontType("bold");
      doc.text(
        `Data Analytic | ${moment(this.dateRange[0]).format("LL")} - ${moment(
          this.dateRange[1]
        ).format("LL")}`,
        5,
        20
      );

      doc.setFontSize(12);
      doc.setFontType("bold");
      doc.text("Cost Saving (MYR)", 5, 35);
      doc.text("Energy Saving (KWh)", 85, 35);
      doc.text("Co2 (KG)", 165, 35);

      doc.setFontSize(10);
      doc.setFontType("normal");
      doc.text(this.costSaving.toString(), 5, 45);
      doc.text(this.energySaving, 85, 45);
      doc.text(this.co2, 165, 45);

      doc.line(5, 50, 205, 50);

      let voltageChart = document.getElementById("line-chart-1");
      let currentChart = document.getElementById("line-chart-2");
      let energyChart = document.getElementById("line-chart-3");
      let brightChart = document.getElementById("pie-chart");

      let voltageImage = voltageChart.toDataURL("image/png", 1);
      let currentImage = currentChart.toDataURL("image/png", 1);
      let energyImage = energyChart.toDataURL("image/png", 1);
      let brightImage = brightChart.toDataURL("image/png", 1);

      doc.setFontSize(12);
      doc.setFontType("bold");
      doc.text(`Voltage usage for : ${this.selects.selectedTime}`, 7, 70);
      doc.addImage(voltageImage, "PNG", 7, 75, 95, 45);

      doc.text(`Current usage for : ${this.selects.selectedTime}`, 110, 70);
      doc.addImage(currentImage, "PNG", 110, 75, 95, 45);

      doc.text(`Energy  usage for : ${this.selects.selectedTime}`, 7, 150);
      doc.addImage(energyImage, "PNG", 7, 155, 95, 45);

      doc.text(
        `Light operating hours : ${this.selects.selectedTime}`,
        110,
        150
      );
      doc.addImage(brightImage, "PNG", 110, 155, 95, 45);

      setTimeout(function () {
        doc.save(`${moment().format("YYYY-MM-DD")}.pdf`);
      }, 5000);
    },
    initPieChart(data) {
      let brightData = [];
      // REMOVE 8AM-6PM TIME
      let removeTime = [
        "8 am",
        "9 am",
        "10 am",
        "11 am",
        "12 pm",
        "1 pm",
        "2 pm",
        "3 pm",
        "4 pm",
        "5 pm",
        "6 pm",
      ];

      for (let i = 0; i < data.length; i++) {
        let isTimeOkay = true;
        for (let j = 0; j < removeTime.length; j++) {
          if (moment.unix(data[i].timestamp).format("h a") == removeTime[j]) {
            isTimeOkay = false;
          }
        }
        if (isTimeOkay) {
          brightData.push(data[i].value);
        }
      }

      brightData.sort(function (a, b) {
        return a - b;
      });

      let newLabel = [...new Set(brightData)];
      let brightLabel = [];
      for (let i = 0; i < newLabel.length; i++) {
        let _label = (newLabel[i] * 10).toString() + "%";
        brightLabel.push(_label);
      }

      let sortedData = [];
      let prev;
      for (var i = 0; i < brightData.length; i++) {
        if (brightData[i] !== prev) {
          sortedData.push(1);
        } else {
          sortedData[sortedData.length - 1]++;
        }
        prev = brightData[i];
      }

      console.log(sortedData);
      console.log(brightLabel);
      // brightLabel = ["50", "70", "90"];
      // sortedData = [3, 5, 4];

      let chartData = {
        labels: brightLabel,
        datasets: [
          {
            label: "Dimm percent",
            pointRadius: 0,
            backgroundColor: [
              "#5D3FB6",
              "#3F9BB1",
              "#8EB542",
              "#FAD01A",
              "#F57C21",
              "#EF4528",
              "#CB0B5B",
              "#EF4530",
              "#CB0B0B",
              "#A9336B",
            ],
            pointHoverRadius: 0,
            borderWidth: 0,
            data: sortedData,
          },
        ],
      };
      this.pieChart2.chartData = chartData;
      this.pieChart2.loaded = true;
    },
    getEnergySaving(data) {
      // if (this.selects.selectedTime == "24 Hours") {
      //   for (let i = 0; i < data.length; i++) {
      //     dayEnergy.push(data[i].value / 1000);
      //   }
      //   totalEnergy = dayEnergy.reduce((a, b) => a + b, 0);
      //   console.log("TOTAL_ENERGU: ", totalEnergy);
      //   newSON = totalEnergy * this.totalLightOn;
      //   this.energySaving = (daySON - newSON).toFixed(2);
      //   this.costSaving = (daySON * tariff - newSON * tariff).toFixed(2);
      //   this.co2 = (totalEnergy * 0.694).toFixed(3);
      // } else {
      //   for (let i = 0; i < data.length; i++) {
      //     dayEnergy.push(data[i].value / 1000);
      //   }
      //   totalEnergy = dayEnergy.reduce((a, b) => a + b, 0);
      //   newSON = totalEnergy * (this.totalLightOn * 7);
      //   daySON *= 7;
      //   this.energySaving = (daySON - newSON).toFixed(2);
      //   this.costSaving = (daySON * tariff - newSON * tariff).toFixed(2);
      //   this.co2 = (totalEnergy * 0.694).toFixed(3);
      // }

      console.log("old SON light rating: ", this.deviceOldSon + " W");
      let dayOldSON = (this.totalLightOn * this.deviceOldSon) / 1000;
      console.log("Daily old SON light energy usage: ", dayOldSON);
      let newSON, oldSON;
      const tariff = this.deviceTariff;
      let dayEnergy = [];
      let totalEnergy = 0;

      for (let i = 0; i < data.length; i++) {
        dayEnergy.push(data[i].value / 1000);
      }

      totalEnergy = dayEnergy.reduce((a, b) => a + b, 0);
      newSON = totalEnergy; //Data ko tarik dah 2 hari energy usage
      // , so xperlu darab dengan light hours and and total hari
      oldSON = dayOldSON * parseInt(this.totalDay);
      this.energySaving = (oldSON - newSON).toFixed(2);
      this.costSaving = (oldSON * tariff - newSON * tariff).toFixed(2);
      this.co2 = (totalEnergy * 0.694).toFixed(3);

      console.log("Electric Tariff: " + tariff);
      console.log(
        "Total energy old SON based on " + this.totalDay + " day: " + oldSON
      );
      console.log(
        "Total energy new LED based on " + this.totalDay + " day: " + newSON
      );
      console.log("Total light operating hours: " + this.totalLightOn);
    },
    daily(data, param) {
      let marshallData = [];
      let start = moment.unix(data[0].timestamp);
      for (let i = 0; i < 7; i++) {
        let store = [];

        for (let j = 0; j < data.length; j++) {
          if (
            start.format("DD") == moment.unix(data[j].timestamp).format("DD")
          ) {
            if (param == "energy") {
              data[j].value != 0 ? store.push(data[j].value) : 0;
            } else {
              data[j].value != 0 ? store.push(data[j].value) : 0;
            }
          }
        }

        if (store.length != 0) {
          if (param == "energy") {
            let avg = store.reduce((a, b) => a + b, 0);
            marshallData.push((avg / 1000).toFixed(3));
          } else if (param == "current") {
            let avg = store.reduce((a, b) => a + b, 0);
            marshallData.push(avg * 10);
          } else {
            let avg = store.reduce((a, b) => a + b, 0) / store.length;
            marshallData.push(avg.toFixed(2));
          }
        } else {
          marshallData.push(0);
        }

        start = start.add(1, "days");
      }

      console.log("RAW_DATA: " + param, data);
      console.log("YAYAYAYA: " + param, marshallData);

      return marshallData;
    },
    initLineGraph(param, data) {
      let timestamp = [];
      let dataValue = [];
      let unit;

      if (param == "voltage") {
        unit = " (V)";
      } else if (param == "current") {
        unit = " (mA)";
      } else if (param == "energy") {
        unit = " (kWh)";
      }

      let chart;

      // REMOVE 8AM-6PM TIME
      let removeTime = [
        "8 am",
        "9 am",
        "10 am",
        "11 am",
        "12 pm",
        "1 pm",
        "2 pm",
        "3 pm",
        "4 pm",
        "5 pm",
        "6 pm",
      ];

      for (let i = 0; i < data.length; i++) {
        let isTimeOkay = true;
        for (let j = 0; j < removeTime.length; j++) {
          if (moment.unix(data[i].timestamp).format("h a") == removeTime[j]) {
            isTimeOkay = false;
          }
        }
        if (isTimeOkay) {
          if (param == "voltage") {
            timestamp.push(moment.unix(data[i].timestamp).format("h:mm a"));
            dataValue.push(data[i].value);
          } else if (param == "energy") {
            timestamp.push(moment.unix(data[i].timestamp).format("h:mm a"));
            dataValue.push(data[i].value / 1000);
          }
        }
      }

      chart = {
        chartData: {
          labels: timestamp,
          datasets: [
            {
              label: param + unit,
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: dataValue,
            },
          ],
        },
        extraOptions: chartConfigs.testChart,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: true,
      };

      if (param == "voltage") {
        this.lineChart1 = chart;
      } else if (param == "current") {
        this.lineChart2 = chart;
      } else if (param == "energy") {
        this.lineChart3 = chart;
      }
    },
    marshallCurrent(voltage, energy) {
      let timestamp = [];
      let dataValue = [];
      let unit = " (mA)";

      // REMOVE 8AM-6PM TIME
      let removeTime = [
        "8 am",
        "9 am",
        "10 am",
        "11 am",
        "12 pm",
        "1 pm",
        "2 pm",
        "3 pm",
        "4 pm",
        "5 pm",
        "6 pm",
      ];

      console.log(voltage);
      console.log(energy);

      for (let i = 0; i < voltage.length; i++) {
        let isTimeOkay = true;
        for (let j = 0; j < removeTime.length; j++) {
          if (
            moment.unix(voltage[i].timestamp).format("h a") == removeTime[j]
          ) {
            isTimeOkay = false;
          }
        }
        if (isTimeOkay) {
          timestamp.push(moment.unix(voltage[i].timestamp).format("h:mm a"));
          dataValue.push((energy[i].value / voltage[i].value).toFixed(2));
        }
      }
      console.log(dataValue);

      let chart = {
        chartData: {
          labels: timestamp,
          datasets: [
            {
              label: "Current" + unit,
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: dataValue,
            },
          ],
        },
        extraOptions: chartConfigs.testChart,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: true,
      };

      this.lineChart2 = chart;
    },
    callLightData(select) {
      this.lineChart2.loaded = false;
      this.lineChart1.loaded = false;
      this.lineChart3.loaded = false;
      let payload = {
        type: "lights",
        params: ["current", "energy", "voltage", "status", "power", "dimm"],
      };

      let today;
      let later;
      let checkDate1 = moment(this.dateRange[0]).format("YYYY-MM-DD");
      let checkDate2 = moment(this.dateRange[1]).format("YYYY-MM-DD");

      if (checkDate1 === checkDate2) {
        let temp1 = moment(this.dateRange[0]);
        let temp2 = moment(this.dateRange[0]);
        today = temp1
          .add(-1, "day")
          .startOf("day")
          .utc()
          .add(19, "hours")
          .unix();
        later = temp2.startOf("day").utc().add(8, "hours").unix();
      } else {
        let temp1 = moment(this.dateRange[0]);
        let temp2 = moment(this.dateRange[1]);
        today = temp1
          .add(-1, "day")
          .startOf("day")
          .utc()
          .add(19, "hours")
          .unix();
        later = temp2.startOf("day").utc().add(8, "hours").unix();
      }

      this.totalDay = (later - today) / 86400 + 1;

      console.log("Today:" + today);
      console.log("Later: " + later);
      console.log("Tota: " + this.totalDay);

      this.$http
        .post(
          `:8001/api/v1/telemetry/device/lights/${this.devicetoken}/${today}/${later}`,
          payload
        )
        .then((res) => {
          console.log(res.message);
          if (res.message.current == null) {
            this.resetChart("voltage");
            this.resetChart("current");
            this.resetChart("energy");
          } else {
            this.initLineGraph("voltage", res.message.voltage);
            this.initLineGraph("energy", res.message.energy);
            // this.initLineGraph("current", res.message.current);
            this.marshallCurrent(res.message.voltage, res.message.energy);
            this.initPieChart(res.message.dimm);
            this.getEnergySaving(res.message.energy);
            this.isLoading = false;
          }
        })
        .catch((error) => {
          this.isLoading = false;
        });
    },
    resetChart(param) {
      let timeStamp = [];
      let today = moment().startOf("day").format("hh:mm a");

      for (let i = 0; i < 24; i++) {
        timeStamp.push(today);
        today = moment(today, "hh:mm a").add(1, "hours").format("hh:mm a");
      }

      let chart = {
        chartData: {
          labels: timeStamp,
          datasets: [
            {
              label: param,
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: true,
      };

      if (param == "voltage") {
        this.lineChart1 = chart;
      } else if (param == "current") {
        this.lineChart2 = chart;
      } else if (param == "energy") {
        this.lineChart3 = chart;
      }

      let chartData = {
        labels: ["10"],
        datasets: [
          {
            label: "Dimm percent",
            pointRadius: 0,
            backgroundColor: [
              "#5D3FB6",
              "#3F9BB1",
              "#8EB542",
              "#FAD01A",
              "#F57C21",
              "#EF4528",
              "#CB0B5B",
              "#EF4530",
              "#CB0B0B",
              "#A9336B",
            ],
            pointHoverRadius: 0,
            borderWidth: 0,
            data: [1],
          },
        ],
      };
      this.pieChart2.chartData = chartData;
      this.pieChart2.loaded = true;
    },
  },

  created() {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    this.dateRange.push(yesterday, today);
    this.deviceID = this.$route.params.deviceid;

    this.getDeviceDetails();
  },
};
</script>

<style scoped>
.analytic el-select {
  display: inline;
}
.il {
  display: inline;
}
</style>
